export default __webpack_public_path__ + "static/media/product-app-1.16e80143.png";